export type MapEngine = "maplibre" | "leaflet";

export function supportsWebGL(documentRef: Document = document): boolean {
  try {
    const canvas = documentRef.createElement("canvas");
    return Boolean(canvas.getContext("webgl2"));
  } catch {
    return false;
  }
}

export function chooseMapEngine(documentRef: Document = document): MapEngine {
  return supportsWebGL(documentRef) ? "maplibre" : "leaflet";
}
